export const CONFIRMATION_DIALOG = {
  headerText: 'Discard Changes?',
  bodyTextContent: 'Are you sure you want to discard the changes?',
  cancelButton: { text: 'Cancel' },
  acceptButton: { text: 'Discard' },
};
